import React from 'react';
import { useSelector } from 'react-redux';
import LanguageSwitcher from './LanguageSwitcher';
import { getCurrentYear } from '../utils';
import { getPublicConfig } from '../reducers';
import './_styles_/Footer.css';

function Footer() {
    const publicConfig = useSelector(getPublicConfig);
    return (
        <div className="footer">
            &copy; 2017, {getCurrentYear()} {publicConfig.customer}; M7 Auction Service v{process.env.REACT_APP_VERSION} | <LanguageSwitcher />
        </div>
    );
}

export default Footer;
